export default [
  {
    path: '/active-study/index',
    name: 'index',
    component: () => import('@/views/active-study/index'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/active-study/rules',
    name: 'rules',
    component: () => import('@/views/active-study/rules'),
    meta: {
      title: '规则'
    }
  },
  {
    path: '/active-study/other',
    name: 'index',
    component: () => import('@/views/active-study/other'),
    meta: {
      title: '加入其他自习室'
    }
  },
]